import { PHONE_NUMBER_PREFIX } from "@common/constants";
import React, { useMemo } from "react";
import { PatternFormat } from "react-number-format";

interface Props {
    phoneNumber: string;
}

export const PhoneNumberDisplay: React.FC<Props> = ({ phoneNumber }) => {
    const phoneNumberWithoutPrefix = useMemo(() => {
        if (phoneNumber.startsWith(PHONE_NUMBER_PREFIX)) {
            return phoneNumber.substring(PHONE_NUMBER_PREFIX.length);
        }
        return phoneNumber;
    }, [phoneNumber]);

    return (
        <PatternFormat
            value={phoneNumberWithoutPrefix}
            displayType="text"
            format="(###) ###-####"
            allowEmptyFormatting
        />
    );
};
